import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminBoxDetailsModalContent } from './modal/modal.component';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { EventsService } from 'app/services/events/events.service';
import { ProductModel } from 'app/models/product-model';
import { FieldFilter, OperatorFilterEnum, OptionFilter } from 'app/models/filter-model';
import { Utils } from 'app/components/utils/Utils';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { BoxDetailsAdminModel } from 'app/models/box-details-admin-model';
import { MassiveActions } from 'app/components/shared/filters/filter.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Constants } from 'app/components/utils/Constants';
import { DataTableSelectionConfig } from 'app/components/shared/data-table/data-table.component';
import { DataTableBadgeTone } from 'app/components/shared/data-table/data-table-badge.component';



@Component({
  selector: 'app-admin-locker',
  templateUrl: './admin-locker.page.html',
  styleUrls: ['./admin-locker.page.scss'],
})
export class AdminLockerPage implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<BoxDetailsAdminModel>;
  totalElements: number = 0;
  pageSize = 100;
  pageIndex = 0;
  fieldFilters: FieldFilter[] = [];
  displayedColumns: string[] = ['select', 'lockerNumber', 'key', 'doorBox', 'channel', 'action'];
  selection = new SelectionModel<BoxDetailsAdminModel>(true, []);
  readonly selectionColumnConfig: DataTableSelectionConfig<BoxDetailsAdminModel> = {
    selection: this.selection,
    canSelect: () => this.validationAction()
  };
  massiveAccions: MassiveActions[] = [
    { key: 'door_box', enabled: false }
  ];
  massiveActionSelected: string = '';

  products: ProductModel;
  cache = new Map();

  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public appService: AppService,
    private eventsService: EventsService) { }

  ngOnInit() {

    this.fieldFilters.push({
      name: 'productId',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('locker.box.search.productId')
    });

    this.getProducts();
    this.searchBoxes();

    this.eventsService.subscribe('updatedFromServer', (result: any) => {
      this.searchBoxes();
    });


    this.getProducts().then(products => {
      let options: OptionFilter[] = products.map(i => {
        return { value: i.productId, label: i.lockerTypeId + '-' + i.lockerSizeId }
      });
      this.fieldFilters.find(i => i.name == 'productId').options = options;
    });

    this.selection.changed.subscribe(rows => {
      if (rows.source.isEmpty()) {
        this.massiveAccions.forEach(accion => accion.enabled = false);
      } else {
        this.massiveAccions.forEach(accion => accion.enabled = true);
      }
    })

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  lockerRowClass = (row: BoxDetailsAdminModel) => ({
    disabled: !row?.enabled,
    hold: !!row?.currentlyReserved
  });

  ngOnDestroy() {
    this.eventsService.destroy('updatedFromServer');
  }


  /** Header checkbox helpers */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  validationAction() {
    return true;
  }

  /**
   * 
   * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
   */
  onPageChange(event: PageEvent) {
    //console.log(event);

    const page = event ? event.pageIndex : this.pageIndex;
    const size = event ? event.pageSize : this.pageSize;

    this.searchBoxes({ action: 'PAGE_CHANGE', page: page, size: size });
  }

  onClickMassiveAction(value: string) {
    if (value == 'door_box') {
      if (!confirm("Esta seguro de realizar la acción?")) {
        return;
      }
      this.selection.selected.forEach(row => this.openDoor(row, false));
    } else {
      alert('error, acción no seleccionada');
    }
  }

  onChangeMassiveActionSelected(value: string) {
    this.massiveActionSelected = value;
  }

  async openDetails(box?: BoxDetailsAdminModel) {
    if(!this.appService.hasRoles(['ROLE_ADMIN'])){
      return;
    }
    
    const products = await this.getProducts();
    const prices = await this.getPrices();

    let dialogRef = this.dialog.open(AdminBoxDetailsModalContent, {
      panelClass: 'responsive-dialog',
      data: { box: box, products: products, priceLocker: prices }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchBoxes());
  }

  openNewBox() {
    this.openDetails();
  }

  mapAsFilters(fieldFilters: any[]) {
    let filters = [];
    let map = [];
    map['date'] = OperatorFilterEnum.BETWEEN;
    map['datetime'] = OperatorFilterEnum.BETWEEN;
    map['time'] = OperatorFilterEnum.BETWEEN;
    map['text'] = OperatorFilterEnum.LIKE;
    map['select'] = OperatorFilterEnum.EQUALS;
    map['number'] = OperatorFilterEnum.LIKE;

    for (let fieldFilter of fieldFilters) {
      if ((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)) {
        filters.push({
          field: fieldFilter.name,
          operator: map[fieldFilter.type],
          value: fieldFilter.value,
          values: fieldFilter.values
        });
      }
    }
    return Utils.generateFilters(filters);
  }

  openDoor(box: BoxDetailsAdminModel, question:boolean=true) {
    if (question && !confirm("Esta seguro de realizar la acción?")) {
      return;
    }
    this.restService.lockerOpenManual(box.lockerNumber).subscribe(result => {
      if (result) {
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      } else {
        this.appService.showDangerToast(Constants.MSG_DANGER);
      }
    });
  }

  getDoorBoxTone(value?: string): DataTableBadgeTone {
    return value === 'OPEN' ? 'warning' : 'success';
  }

  getDoorBoxIcon(value?: string): string {
    return value === 'OPEN' ? 'lock_open' : 'lock';
  }

  getChannelTone(value?: string): DataTableBadgeTone {
    switch (value) {
      case 'ANY_CHANNEL':
        return 'primary';
      case 'ONLINE_CHANNEL':
        return 'info';
      case 'IN_STORE_CHANNEL':
        return 'success';
      default:
        return 'neutral';
    }
  }

  getChannelIcon(value?: string): string {
    switch (value) {
      case 'ANY_CHANNEL':
        return 'all_inclusive';
      case 'ONLINE_CHANNEL':
        return 'cloud';
      case 'IN_STORE_CHANNEL':
        return 'person';
      default:
        return 'help_outline';
    }
  }

  searchBoxes({ page = this.pageIndex, size = this.pageSize, action = null }: { page?: number; size?: number; action?: string; } = {}) {

    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=lockerNumber,asc';
    let pageSize = "&page=" + page + '&size=' + size;

    this.restService.searchBoxes(filters + sort + pageSize).subscribe(result => {
      this.dataSource.data = result.content;
      this.totalElements = result.totalElements;     // total global
      this.pageSize = result.pageSize;               // tamaño actual
      this.pageIndex = result.pageNumber;            // índice actual
      this.selection.clear();
    }, (err => {
      this.dataSource.data = [];
      this.totalElements = 0;
      this.selection.clear();
    }));
  }

  async getProducts() {
    if (this.cache.has('product')) {
      return this.cache.get('product');
    } else {
      const result = await firstValueFrom(this.restService.getProducts());
      this.cache.set('product', result);
      return result;
    }
  }

  async getPrices() {
    if (this.cache.has('priceLocker')) {
      return this.cache.get('priceLocker');
    } else {
      const result = await firstValueFrom(this.restService.getPrices());
      this.cache.set('priceLocker', result);
      return result;
    }
  }

}
